import { getIsDefaultTheme } from "../styles/themes/themeSelection";
import { useTheme } from "../styles/themes/themeContext";
import { LeaftechLogo } from "./Logo";
import { defaultTheme } from "../styles/themes/themeSelection";

export default function PoweredBy() {
  const theme = useTheme();
  if (getIsDefaultTheme(theme.name)) return null;
  return (
    <div className="powered-by">
      <h3>POWERED BY</h3>
      <LeaftechLogo
        imgProps={{ style: { height: defaultTheme.logo.height } }}
      />
    </div>
  );
}
